import { LoadType } from '@tencent/ark-extensions';

/**
 * 版本管理组件
 */
export default {
    name: 'docs-component-record',
    loadType: LoadType.ON_DEMAND,
};
